import React, { useEffect, useState } from "react";
import { db } from "../FireBase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { Bed } from "lucide-react";
import { Button } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import RoomCard from "../components/FetRoomCard";
import '../css/FeturedList.css'

const FeaturedRooms = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bookingCounts, setBookingCounts] = useState({});
  const bestSellerTagId = "Xb9aAWeCL4TO6lyYOnbQ";
  const STORAGE_KEY = 'bookingSearch';
    const [range, setRange]= useState({ from: undefined, to: undefined });

    useEffect(() => {
      
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
          try {
            const { from, to } = JSON.parse(saved);
            setRange({
              from: from ? new Date(from) : undefined,
              to:   to   ? new Date(to)   : undefined,
            });
       
          } catch {}
        }
      
    }, []);
  useEffect(() => {
    const fetchFeaturedRooms = async () => {
      setLoading(true);
      try {
        const q = query(
          collection(db, "rooms"),
          where("tags", "array-contains", bestSellerTagId)
        );
        const querySnapshot = await getDocs(q);
        const fetchedRooms = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setRooms(fetchedRooms); // ✅ update state first
      } catch (error) {
        console.error("Error fetching featured rooms:", error);
        setRooms([]);
      } finally {
        setLoading(false);
      }
    };
  
    fetchFeaturedRooms();
  }, []);
  
  useEffect(() => {
    const fetchBookings = async (roomIds) => {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      const checkinISO = formatDateForOrder(range?.from);
      const checkoutISO =formatDateForOrder(range?.to);
       if (!checkinISO || !checkoutISO) {
    console.warn("Skipping fetchBookings — missing date range");
    return;
  }
      const bq = query(
        collection(db, 'room_bookings'),
        where('checkIn', '<', checkoutISO),
        where('checkOut', '>', checkinISO),
        where('status', '==', 'booking-confirmed')
      );
      const snap = await getDocs(bq);
      const counts = {};
      snap.docs.forEach(doc => {
        const { roomId ,roomCount = 1 } = doc.data();
        if (roomIds.includes(roomId)) {
          counts[roomId] = (counts[roomId] || 0) + roomCount;
        }
      });
      console.log(counts)
      setBookingCounts(counts);
    };
  
    if (rooms.length > 0) {
      const roomIds = rooms.map(r => r.id);
      fetchBookings(roomIds);
    }
  }, [rooms]);
        const formatDateForOrder = (date) => {
    return date?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };
  
  return (
    <>
      <div className="d-flex justify-content-between align-items-center w-100">
        <h4 className="mb-4" style={{ color: '#0d3b66', fontWeight: 600 }}>
          Featured Rooms
        </h4>
        <Link to="/rooms" style={{ textDecoration: 'none' }}>
          <Button className="btn-sm d-flex align-items-center btn-own" style={{ padding: '5px 12px' }}>
            <span style={{ marginRight: '6px' }}>Explore</span>
            <Bed size={16} />
          </Button>
        </Link>
      </div>

      <div 
        className="d-flex gap-3 overflow-auto hide-scrollbar"
        style={{ scrollBehavior: "smooth" }}
      >
        {loading ? (
          [...Array(4)].map((_, idx) => (
            <div key={idx} style={{ width: '300px' }}>
              <Skeleton height={200} />
              <Skeleton height={20} />
              <Skeleton height={20} />
            </div>
          ))
        ) : (
          rooms.slice(0, 10).map(room => (
            <RoomCard 
              key={room.id} 
              room={room} 
              bookingCount={bookingCounts[room.id]} 
            />
          ))
        )}
      </div>

    </>
  );
};

export default FeaturedRooms;
